import { axiosGet, axiosPost } from '../../../../axios/axios'
import { mapActions, mapGetters } from 'vuex'

export const userSettingsManager = {
  computed: {
    ...mapGetters({ user: 'getUser' })
  },
  methods: {
    ...mapActions({
      setUser: 'setUser'
    }),
    loadUserSettings: function () {
      return axiosGet({
        url: '/service/delta/user/settings/get?config=true',
        onSuccess: response => response.data.result,
        onFailure: 'Ошибка загрузки настроек пользователя',
        throws: true
      })
    },
    saveUserSettings: async function (changedSettingsData) {
      if (!changedSettingsData) {
        return Promise.resolve()
      }

      const bodyFormData = new FormData()
      bodyFormData.set('data', JSON.stringify(changedSettingsData))

      return axiosPost({
        url: '/service/delta/user/settings/set',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Настройки сохранены',
            progress: true,
            timeout: 3000
          })

          this.user.settings = response.data.result
          this.setUser(this.user)
        },
        onFailure: (response) => {
          const message = response.message || 'Ошибка сохранения настроек'
          this.$q.notify({
            type: 'negative',
            message: message,
            progress: true,
            timeout: 8000
          })
          // TODO частичное обновление настроек
          return Promise.reject(new Error(message))
        }
      })
    }
  }
}
